import React from 'react';

//Components
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'


//Styles
import Styles from './PhoneNumberInput.module.scss';

//Utils
import PropTypes from 'prop-types';

const PhoneNumberInput = ({validationError = null, name, value, setInputValue }) => {

    const changeHandler = (val) => { 
        setInputValue(val)
    }
 
    return ( 
        <div className={Styles.container}>
            {
                validationError !== null ? 
                <label className={Styles.error}>
                    {validationError}
                </label> :
                <label className={Styles.focus}>
                    {name}
                </label> 
            }
            <PhoneInput
                inputClass={Styles.input}
                placeholder="Enter phone number"
                value={value}
                style={{borderBottom: validationError ?  '1px solid red' : '1px solid #D8E1EA'}}
                onChange={val => changeHandler(val)}
            />
        </div>
    );
};

PhoneNumberInput.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    name: PropTypes.string.isRequired,
    rules: PropTypes.object,
    setInputValue: PropTypes.func.isRequired
};

export default PhoneNumberInput
